import APIClient from '@/shared/http/clients/api'

const resourceName = 'user-sessions'
const APICore = process.env.APIBaseURLCore

const GetAllReportAcessos = (limit, index, config = {}) => {
  return APIClient.get(`${APICore}/${resourceName}?page=${index}&size=${limit}`, config)
}

const ReportAcessoRepository = {
  GetAllReportAcessos
}

export default ReportAcessoRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/reports/reportAcessos.js